import chart1 from './chart1.svg';
import chart2 from './chart2.svg';
import chart3 from './chart3.svg';
import chartAll from './chartAll.svg';
import sliderHandler from './slider-handler.svg';

export const iconsBcp = {
	sliderHandler,
	chart1,
	chart2,
	chart3,
	chartAll,
};
